import React, { useContext, useEffect, useState } from "react";
import SelectCustomer from "./SelectCustomer";
import { Divider, Grid, IconButton } from "@mui/material";
import { Button } from "../../../../../controls";
import { Model, UseForm } from "../../../../../hooks";
import { CloseRounded } from "@mui/icons-material";
import { action, API, controller } from "../../../../../api/api";
import {
  BGNestedObjToFromData,
  lsGet,
  PrintDiv,
  RmvEmptyProp,
} from "../../../../../hooks/Method";
import { AppContext } from "../../../../../App";
import CustomerDetails from "./CustomerDetails";
import { CartContext } from "../../POS";

const QuoteForm = ({ setShowForm, setAlert, setQuoteReceiptData }) => {
  const { QuoteMdl, SellMdl } = Model();
  const { authUser } = useContext(AppContext);
  const { cartData, setCartData } = useContext(CartContext);
  const activeReg = lsGet("activeReg");
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(QuoteMdl);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let temp = {};
    temp.phone = values.phone !== "" ? "" : "Phone is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  // Cart Properties for to quote sale.
  useEffect(() => {
    if (cartData.sellItems.length > 0) {
      setValues((j) => ({
        ...j,
        quoteItems: cartData.sellItems.map((j) => ({
          ...j,
          prod: "",
          varProd: "",
        })),
        sellRegId: activeReg.id,
        outletId: activeReg.outletId,
        orgId: authUser.orgId,
        servedUserId: authUser.id,

        // Cart Properties
        customerId: cartData.customerId,
        discount: cartData.discount,
        disType: cartData.disType,
        disAmt: cartData.disAmt,
        taxId: cartData.taxId,
        taxRate: cartData.taxRate,
        taxAmt: cartData.taxAmt,
        subtotal: cartData.subtotal,
        totalPay: cartData.netPayable,
        note: cartData.note,
        createDate: new Date().toISOString(),
      }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      validateForm() &&
      authUser &&
      authUser.id &&
      cartData.sellItems.length > 0
    ) {
      setLoading(true);
      const onComplete = (res) => {
        if (res && res.status === 200) {
          setQuoteReceiptData({ ...res.result });
          setTimeout(() => {
            PrintDiv("printQuoteReceipt");
            setCartData(SellMdl);
            setShowForm(false);
          }, 500);
        } else if (res && res.msg)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };

      API(controller.QuoteSale + action.Post).post(
        BGNestedObjToFromData(RmvEmptyProp(values)),
        onComplete
      );
    }
  };

  const handleClose = () => {
    setShowForm(false);
    resetFormControls();
  };

  return (
    <div>
      <div className="flex justify-between items-center gap-3 p-[10px] pb-[5px]">
        <div>
          <span className="border-left text-[20px] font-medium text-gray-500 uppercase">
            Create Quote
          </span>
        </div>
        <IconButton onClick={handleClose} size="small">
          <CloseRounded />
        </IconButton>
      </div>
      <Divider className="!mb-[10px]" />

      <Grid container spacing={2} className="p-[15px]">
        <Grid item xs={12}>
          <SelectCustomer {...{ values, setValues }} />
        </Grid>

        <Grid item xs={12}>
          <CustomerDetails {...{ values, setValues, errors, handleInpChg }} />
        </Grid>

        <Grid item xs={12} className="text-right">
          <Button
            onClick={handleSubmit}
            size="large"
            loading={loading}
            disabled={!values.customerId}
          >
            Create Quote
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default QuoteForm;
